<mat-form-field [nbSpinner]="isSetting">
    <mat-select #algoliaSelect selectScroll (selectScroll)="onScroll()" [isLoading]="isNext"
        [disableLoading]="disableNext" matTooltip="Enter 3 words to search..." [required]="required"
        [placeholder]="placeholder" [formControl]="bankControl" panelClass="algolia-search-option">
        <mat-select-trigger *ngIf="(bankControl?.value | findItem: state?.indices?.[0]?.hits : propValue) as item">
            <ng-container *ngIf="item" [ngTemplateOutlet]="itemOption" [ngTemplateOutletContext]="{
                            highLight: item?.['_highlightResult'],
                            option: item
                        }">
            </ng-container>
        </mat-select-trigger>
        <mat-option>
            <ngx-mat-select-search [formControl]="bankSearch" [placeholderLabel]="placeholderLabel"
                noEntriesFoundLabel="No matching item found">
            </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngIf="isNext">
            <ngx-skeleton-loader class="custom-loader-select-algolia" count="1" appearance="line" animation="progress"
                [theme]="{
                    height: '2px',
                    margin: '0',
                    padding: '0',
                    'border-radius': '10px',
                    background: '#83bef4'
                }"></ngx-skeleton-loader>
        </mat-option>
        <mat-option style="height: 36px !important;" [disabled]="true">
            About {{(state?.indices?.[0]?.['results']?.['nbHits'] || 0) | numberFormat}} result(s) match
        </mat-option>
        <ng-container *ngFor=" let index of state.indices || []">
            <mat-option *ngFor="let option of index.hits" [value]="option[propValue]">
                <ng-container *ngIf="option?.['_highlightResult'] as highLight" [ngTemplateOutlet]="itemOption"
                    [ngTemplateOutletContext]="{
                            highLight: highLight,
                            option: option
                        }">
                </ng-container>
            </mat-option>
        </ng-container>
    </mat-select>
    <mat-error *ngIf="bankControl?.errors && (bankControl?.dirty || bankControl?.touched)">
        {{bankControl?.['errorMessage']}}
    </mat-error>
</mat-form-field>

<ng-template #itemOption let-highLight="highLight" let-option="option">
    <div fxLayout="row" fxLayoutAlign="space-between center" class="option-card" fxLayoutGap="0.5rem">
        <div fxFlex="calc(100% - 150px - 0.5rem)" fxLayout="row" fxLayoutAlign="start start">
            <img fxFlex="60px" [src]="(option?.['media'] | formatImageUrl) || ('assets/images/5.jpg' | formatImageUrl)"
                width="60px" height="60px" style="object-fit: cover;">
            <div fxFlex="calc(100% - 60px)  " class="ml-2">
                <div class="font-weight-bold text-truncate mb-2"
                    [innerHtml]="((highLight?.[propDisplay]?.value || option?.[propDisplay]) | parseSafeHtml) | safeHtml">
                </div>
                <div class="font-italic text-truncate"
                    [innerHtml]="((highLight?.['realName']?.value || option?.['realName']) | parseSafeHtml) | safeHtml">
                </div>
            </div>
        </div>
        <div fxFlex="150px"
            *ngIf="(option?.['automateDataStateId'] | findItem: (automateDataStateLst || []) : 'automateDataStateId') as state">
            <span class="badge badge-pill badge-primary text-truncate" style="font-size:11px"
                [style.background-color]="state?.colorCode || '#000'">
                {{state?.dataStateName || 'Unknown'}}
            </span>
        </div>
    </div>
</ng-template>